import { makeRequest } from 'utils/requestLogger';

export default (participationID, content) =>
  makeRequest('put', `/api/participations/${participationID}/edit_notes`, {
    content,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/editStudentNotes.js